import { useEffect } from "react";
import { FieldValues, UseFormRegister, UseFormSetValue, UseFormWatch } from "react-hook-form";

const ALLOWED_FILE_EXTENSIONS = [".png", ".jpg", ".jpeg", ".webp", ".csv", ".xlsx", ".pdf"];

interface AttachmentBoxProps {
  register: UseFormRegister<FieldValues>;
  watch: UseFormWatch<FieldValues>;
  id: string;
  required?: boolean | string;
  setValue: UseFormSetValue<FieldValues>;
}

const AttachmentBox: React.FC<AttachmentBoxProps> = ({ register, watch, id, required = false, setValue }) => {
  const files: File[] = watch(id) || [];
  function addFiles(value: React.ChangeEvent<HTMLInputElement>) {
    if (value.target.files) {
      setValue(id, [...files, ...Array.from(value.target.files)]);
    }
  }
  function handleRemoveFiles(index: number) {
    const _filteredFiles = [...files];
    _filteredFiles.splice(index, 1);
    setValue(id, _filteredFiles);
  }

  useEffect(() => {
    register(id, { required });
  }, []);

  return (
    <>
      <div className="file-input">
        <div>Add Attachments</div>
        <input
          type="file"
          id="file"
          accept={ALLOWED_FILE_EXTENSIONS.join(", ")}
          className="file"
          onChange={addFiles}
          multiple
        />
        <label htmlFor="file">SELECT FILE</label>
        {files?.map((file, index) => (
          <div className="flex items-center gap-3" key={file.name + index}>
            <div className="cursor-pointer" onClick={() => handleRemoveFiles(index)}>
              X
            </div>
            <div>{file.name}</div>
          </div>
        ))}
      </div>
    </>
  );
};

export default AttachmentBox;
